import React from "react";
import "../css/paymentmodal.css";
import defaultProfile from "../assets/Male 1.svg";
import { useSelector } from "react-redux";
import { formatDate } from "../utils/utilities";
const UserHeader = () => {
    const {
        selectedDoctor,
        selectedSpecialization,
        selectedAppointment,
    } = useSelector((state) => state.appointment) || {};

  return (
    <div
      className="d-flex align-items-center justify-content-between rounded my-3 position-relative topdivbar"
      style={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)" }}
    >
      <div className="bar"></div>
      <div className="d-flex align-items-center ms-4">
        <img
          src={selectedDoctor?.image ?? defaultProfile}
          className="rounded-circle user-image"
          alt="..."
        />
        <div className="f600-16px">{selectedDoctor.label}</div>
      </div>
      <div className="f500-14px">{selectedSpecialization.label}</div>
      <div className="f500-14px">{formatDate(selectedAppointment.date)}</div>
      <div
        className="px-4 rounded  f500-14px"
        style={{ backgroundColor: "#D9D9D9" }}
      >
        {selectedAppointment.time}
      </div>
    </div>
  );
};

export default UserHeader;
